import { RootState } from '../root.reducers';
import { XtpXdpConnection, XtpXdpConnectionProtocol, XtpXdpConnectionUiState } from './xtp-xdp-connection.types';

export const getXtpXdpsConnectionList = (state: RootState): XtpXdpConnectionProtocol[] => state.xtpXdpConnection.entities;

export const getXtpXdpsConnection = (state: RootState): XtpXdpConnection | undefined => state.xtpXdpConnection.single;

export const getSelectedXtpXdpsConnection = (state: RootState): XtpXdpConnectionProtocol[] => state.xtpXdpConnection.selected;

export const getXtpErrors = (state: RootState): { connection: string, protocols: string[], } => state.xtpXdpConnection.errors;

export const getUiState = (state: RootState): XtpXdpConnectionUiState => state.xtpXdpConnection.ui;
